import $ from 'cash-dom'
import media from '../media.js'

export default class NavModule {

    static name = 'nav'

    constructor(node) {

        this.$nav = $(node)
        this.$body = $('body')

        this.timeout = null
        this.wasPlayerVisible = true

        this.$nav
            .on('click', '.nav__toggle', this.open)
            .on('click', '.nav__overlay, .nav__close', this.close)

            .on('click', 'a', e => {
                
                this.close()

                //block any interaction until the nav layer is closed
                //0.6s transition + some good measure
                this.$nav.addClass('inactive')
                window.setTimeout(() => {
                    this.$nav.removeClass('inactive')
                }, 1000);
            })

            .on('mouseover', '.nav__item', this.open)
            .on('mouseleave', this.close)
    }

    open = () => {
        
        if(this.$nav.hasClass('active')) return

        this.$nav.addClass('active')
        window.clearTimeout(this.timeout)
        this.$body.addClass('nav-open')

        //hide player
        if(media.mobilenav.matches) {
            this.wasPlayerVisible = window.player1?.controller_do.isShowed_bl
            window.player1?.hidePlayer()
        }
    }

    close = () => {

        this.$nav.removeClass('active')
        this.timeout = window.setTimeout(() => this.$body.removeClass('nav-open'), 600)

        //show player (if it was previously visible)
        if(this.wasPlayerVisible) {
            window.player1?.showPlayer()
        }
    }
}